// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"7c6b589d","428":"d9a56a86","488":"ba5b7ddd","508":"bdcc9961","568":"b2b36c90","736":"f267031d","812":"292ccf1d"}[chunkId] + ".chunk.css";
};